const swea = require('swea');
const CameraRectangleInteraction = swea.editor.interactions.CameraRectangleInteraction;
const InstructionServiceActions = swea.react.actions.InstructionServiceActions;
const InstructionService = swea.react.services.InstructionService;
const ViewerManager = swea.editor.ViewerManager;


class CustomCameraRectangleInteraction extends CameraRectangleInteraction {
  /**
   * Constructs the interaction.
   * @param { object } options An option object, see {@link CameraRectangleInteraction} for more info.
   * @public
   */  
  constructor(options = {}) {
    super(options);
  }
  
  /**
   * Initializes the interaction.
   * @param element the element that the interaction listens to.
   * @param viewerId the viewer id of the viewer the interaction operates in.
   */
  initialize(element, viewerId) {
    super.initialize(element, viewerId);

    // When user closes the tool
    this.addTrigger(new swea.editor.interactions.EventHandler(
      [swea.editor.interactions.eventCodes.ESC],
      this,
      () => {
        this.terminate();
      }
    ));
  }
  
  /**
   * When the interaction is initialized, set instruction and crosshair cursor.
   * @param element { DOMElement } The element that the interaction works on
   * @param viewerId { number } The ID of the viewer.
   * @override
   */
  whenInitialized(element, viewerId){
    super.whenInitialized(element, viewerId);
    InstructionServiceActions.showInstruction('instructions.camera_rectangle');
    ViewerManager.instance().getViewerById(viewerId).setCursor('crosshair');
  }

  /**
   * Hook that is called after termination, hiding instruction and setting default cursor.
   * @param { Element } element The DOM element.
   * @param { number } viewerId The viewer id.
   * @public
   * @override
   */
  whenTerminated(element, viewerId){
    super.whenTerminated(element, viewerId);
    const state = InstructionService.instance().getState();
    if (state.isOpen && state.text === swea.i18n.t('instructions.camera_rectangle')) {
      InstructionServiceActions.hideInstruction();
    }
    ViewerManager.instance().getViewerById(viewerId).setCursor('default');
  }
}
export default CustomCameraRectangleInteraction;
